module.exports = __webpack_public_path__ + "static/img/sfnuanxin.ace8006.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sustainable/community/sfnuanxin.jpg
// module id = S6bz
// module chunks = 2